module.exports = __webpack_public_path__ + "static/media/application_pending.c807489a.svg";